import React, {useCallback, useEffect, useRef, useState} from 'react';
import {NavBar} from "./navigate/NavBar";
import {ReactComponent as LogoIcon} from '../../assets/header/logo.svg';
import {ReactComponent as ProfileIcon} from '../../assets/header/profile.svg';
import {ReactComponent as CloseIcon} from '../../assets/header/сlose.svg';
import {ReactComponent as BurgerMenuIcon} from '../../assets/header/burger-menu.svg';
import {Link} from "react-router-dom";
import {Contacts} from "./contacts/Contacts";
import {useAppDispatch, useAppSelector} from "common/hook";
import {setOpenBurgerAC} from "app/app-reduser";
import {Avatar} from "../pages/groups/group-container/main-top/top-controls/controls-user/avatar/Avatar";
import {getProfileData} from "entities/Profile/model/selectors/getProfileData/getProfileData";
import {
    ProfileOptions
} from "components/pages/groups/group-container/main-top/top-controls/controls-user/profile-options/ProfileOptions";
import {logoutByUser} from "features/model/service/logout-by-user/LogoutByUser";
import useOutsideClick from "common/hook/useOutsideClick";

export const Header = () => {
    const isOpenBurger = useAppSelector(state => state.app.isOpenBurger);
    const dispatch = useAppDispatch();
    const overlayRef = useRef<HTMLDivElement | null>(null);
    const isLogin = useAppSelector(state => state.accountUser.isLogin);
    const dataProfile = useAppSelector(getProfileData);
    const [openHeader, setOpenHeader] = useState(false);
    const [open, setOpen] = useState(false);
    const profileSelectRef = useOutsideClick(() => setOpen(false));

    const avatarSrc = dataProfile?.avatar || null;

    const handleBurgerToggle = useCallback(() => {
        dispatch(setOpenBurgerAC(!isOpenBurger));
    }, [dispatch, isOpenBurger]);

    const onClickSelectHandler = () => {
        setOpen(!open);
    };

    const onLogout = useCallback(() => {
        dispatch(logoutByUser());
    }, [dispatch]);

    const handleKeyDown = useCallback((event: KeyboardEvent) => {
        if (event.key === 'Escape' && isOpenBurger) {
            handleBurgerToggle();
        }
    }, [handleBurgerToggle, isOpenBurger]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    const handleHeaderToggle = useCallback(() => {
        setOpenHeader(!openHeader);
    }, [openHeader]);


    useEffect(() => {
        const handleOverlayClick = () => {
            dispatch(setOpenBurgerAC(false));
        };

        if (overlayRef.current) {
            overlayRef.current.addEventListener('click', handleOverlayClick);
        }

        return () => {
            if (overlayRef.current) {
                overlayRef.current.removeEventListener('click', handleOverlayClick);
            }
        };
    }, []);




    return (
        <div>
            {isLogin && (
                <header className="app-header">
                    <div className={isOpenBurger ? "container" : "container opened-nav"}>
                        <div className="hdr-logo-box">
                            <Link to="/"
                                  className="hdr-logo"
                                  title="На главную"
                            >
                                <LogoIcon/>
                            </Link>
                        </div>
                        <div className="app-nav-box">
                            <div className="profile-prompt">
                                <ProfileIcon/>
                            </div>
                            <NavBar/>
                            <Contacts/>
                            <div className="app-nav-overlay" ref={overlayRef}></div>
                        </div>
                        <span
                            onClick={handleBurgerToggle}
                            className="js-open-nav">
                            {isOpenBurger ? <CloseIcon/> : <BurgerMenuIcon/>}
                        </span>
                        <div className="app-profile"
                             onClick={onClickSelectHandler}
                             ref={profileSelectRef}>
                            <Avatar
                                avatarSrc={avatarSrc}
                                onClick={handleHeaderToggle}
                                openHeader={openHeader}
                            />
                            <ProfileOptions
                                open={open}
                                onLogout={onLogout}
                            />
                        </div>
                    </div>
                </header>
            )}
        </div>
    );
}
